import { TOKEN_KEY } from "../../../Utils/Constants";
import { baseUrl } from "../../../shared/baseUrl";
import { createNotification } from "../../Common/CreateNotification";

export const createMessage = async ({ sellerId, customerId, message }) => {
  try {
    const res = await fetch(
      baseUrl + `chat?seller_id=${sellerId}&message=${message}&customer_id=${customerId}`,
      {
        method: "POST",
        headers: {
          Authorization:
            localStorage.getItem(TOKEN_KEY) !== null
              ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
              : null,
        },
      }
    );
    if(res.success){
        createNotification("Message sent")
    }
  } catch (error) {
    createNotification(error,"Error sending message")
  }
};
